import React, { useEffect, useState } from "react";

// https://www.geodatasource.com/developers/javascript
function distance(position1,position2){
  var lat1 = parseFloat(position1.Lat);
  var lat2 = parseFloat(position2.lat);
  var lon1 = parseFloat(position1.Lng);
  var lon2 = parseFloat(position2.lng);

  var radlat1 = Math.PI * lat1/180;
  var radlat2 = Math.PI * lat2/180;
  var theta = lon1-lon2;
  var radtheta = Math.PI * theta/180;
  var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  if (dist > 1) {
    dist = 1;
  }
  dist = Math.acos(dist);
  dist = dist * 180/Math.PI;
  dist = dist * 60 * 1.1515;
  return dist;
}

Array.prototype.sortOn = function(key){
    this.sort(function(a, b){
        if(a[key] < b[key]){
            return -1;
        }else if(a[key] > b[key]){
            return 1;
        }
        return 0;
    });
}


const Locations = (props) => {
  const [locations, setLocations] = useState({});
  const [loadingLocations, setLoadingLocations] = useState(true);

  let pickupOrDelivery = '';
  // if we are delivering, we filter by city since Delivery is based on which towns they deliver to
  if ('delivery' === props.pickupOrDelivery) {
    pickupOrDelivery = '{Delivery}=1';
  } else {
    pickupOrDelivery = '{Pickup}=1';
  }

  let rangeSearchString = '';
  let deliveryAreaSearchString = '';

  // filter by 1 degree Latitude (-0.5, 0.5) and Longitude (-0.5, 0.5) of the shopper's location
  if (props.shopperLocation && 'pickup' === props.pickupOrDelivery) {
    // console.log(props.shopperLocation);
    let lat1 = parseFloat(props.shopperLocation.lat, 10);
    lat1 = lat1 - 0.5;
    let lat2 = lat1 + 1.0;
    let lng1 = parseFloat(props.shopperLocation.lng, 10);
    lng1 = lng1 - 0.5;
    let lng2 = lng1 + 1.0;
    // console.log(lat1,lat2,lng1,lng2);
    rangeSearchString = ',{Lat}>' + lat1 + ',{Lat}<' + lat2 + ',{Lng}>' + lng1 + ',{Lng}<' + lng2;
  } else if ('delivery' === props.pickupOrDelivery) {
    deliveryAreaSearchString = ',SEARCH("' + props.shopperLocation.city + '", {DeliveryAreas})';
  }

  let searchParams = new URLSearchParams({
    'filterByFormula': 'AND(' + pickupOrDelivery + rangeSearchString + deliveryAreaSearchString + ',{Visible}=1)'
  });

  // https://airtable.com/appNZ3Lf5arpmocRF/api/docs#curl/table:table%201:list
  // have to hard code this URLSearchParams doesn't format the array correctly
  let fields = "fields[]=Name&fields[]=DeliveryURL&fields[]=PickupURL&fields[]=City&fields[]=State&fields[]=Lat&fields[]=Lng&fields[]=DeliveryAreasLookup&fields[]=Image";
  const bearer = "Bearer " + process.env.REACT_APP_AIRTABLE_API;

  useEffect(() => {
    setLoadingLocations(true);

    fetch("https://api.airtable.com/v0/appNZ3Lf5arpmocRF/Locations?" + fields + "&" + searchParams, {
      headers: {
        'Authorization': bearer
      }
    })
      .then((res) => res.json())
      .then((data) => {
        if ('delivery' === props.pickupOrDelivery) {
          // console.log("DELIVERY");
          setLocations(data.records);
        } else {
          // console.log("PICKUP");
          setLocations(sortByDistance(data.records, props.shopperLocation));
        }
        setLoadingLocations(false);
        // console.log(data);
      })
      .catch((error) => {
        console.log(error);
        setLoadingLocations(false);
      });
  }, [props.shopperLocation, props.pickupOrDelivery]);

  function sortByDistance(records, shopperLocation) {
    // calculate distances based on location
    records.map((record) => (
      record.distance = distance(record.fields, shopperLocation)
    ));
    // sort
    records.sortOn('distance');
    return records;
  }

  function LocationImage(props) {
    if (props.recordImage && props.recordImage.length > 0) {
      return (
        <div className="store-image">
          <img src={props.recordImage[0]['thumbnails']['large']['url']} />
        </div>
      );
    } else {
      return (<div className="store-image"></div>)
    }
  }

  function DeliveryOptions() {
    return (
      <div className="store-location">
        <h3>Delivery</h3>
        {locations.slice(0,10).map((record) => (
          record.fields.DeliveryURL && <a href={record.fields.DeliveryURL} key={record.id} target="_blank" className="store-row">
            <LocationImage recordImage={record.fields['Image']} />
            <div className="store-info">
              <span className="store-name">{record.fields.Name}</span>
              <span>Delivery areas: {record.fields.DeliveryAreasLookup && record.fields.DeliveryAreasLookup.join(', ')}</span>
            </div>
          </a>
        ))}
      </div>
    );
  }

  function PickupOptions() {
    return (
      <div className="store-location">
        <h3>Pickup</h3>
        {locations.slice(0,10).map((record) => (
          record.fields.PickupURL && <a href={record.fields.PickupURL} key={record.id} target="_blank" className="store-row">
            <LocationImage recordImage={record.fields['Image']} />
            <div className="store-info">
              <span className="store-name">{record.fields.Name}</span>
              <span>{record.fields.City}, {record.fields.State} - {record.distance && record.distance.toLocaleString(undefined, {maximumFractionDigits:2})} miles away</span>
            </div>
          </a>
        ))}
      </div>
    );
  }

  function LoadingLocations() {
    return (
      <div className="store-notice">
        <h3>Loading...</h3>
      </div>
    );
  }

  function NoOptions() {
    return (
      <div className="store-notice">
        <h3>Oops!</h3>
        <p>No stores available for {props.pickupOrDelivery}.</p>
        <p>We currently only serve Massachusetts. If you'd like us to bring Good Feels to your state, <a href="mailto:hello@getgoodfeels.com">email us</a>.</p>
      </div>
    );
  }

  return (
    <div id="list-of-locations">
      { locations.length > 0 ? (
        'delivery' === props.pickupOrDelivery ? <DeliveryOptions /> : <PickupOptions />
      ) : (
        loadingLocations ? <LoadingLocations /> : <NoOptions />
      )}
    </div>
  );
}
export default Locations;
